import Vue from 'vue'
import Router from 'vue-router'
import Login from "../components/Login";
import Index from "../components/Index";
import UserList from "../components/config/UserList";
import RoleList from "../components/config/RoleList";
import Permission from "../components/config/Permission";
import GameList from "../components/product/GameList";
import GameLabelList from "../components/product/GameLabelList";
import DataReport from "../components/report/DataReport";
import IndexConfig from "../components/ruleconfig/IndexConfig";
import FunctionReport from "../components/report/FunctionReport";
import ChannelList from "../components/product/ChannelList";
import EventList from "../components/product/EventList";
import EventReport from "../components/report/EventReport";
import MatrixReport from "../components/report/MatrixReport";
import PlateGameReport from "../components/report/PlateGameReport";
import JumpGameReport from "../components/report/JumpGameReport";
import MatrixConfig from "../components/ruleconfig/MatrixConfig";
import ModelConfig from "../components/ruleconfig/ModelConfig";
import DiscoverConfig from "../components/ruleconfig/DiscoverConfig";
import DiscoverList from "../components/newProject/womens/DiscoverList";
import DiscoverDetail from "../components/newProject/womens/DiscoverDetail";

import BannerDiscoverDetail from "../components/newProject/womens/BannerDiscoverDetail";
import RemenDiscoverDetail from "../components/newProject/womens/ReMenDiscoverDetail";
import WenzhangDiscoverDetail from "../components/newProject/womens/WenZhangDiscoverDetail";

import AdConfig from "../components/ruleconfig/AdConfig";
import VideoReport from "../components/report/VideoReport";
import GameSourceReport from "../components/report/GameSourceReport";
import MiniReport from "../components/report/MiniReport";
import ActivityConfig from "../components/operation/ActivityConfig";
import ActivitySummary from "../components/operation/ActivitySummary";
import PrizeReport from "../components/operation/PrizeReport";
import AddPrize from "../components/operation/daily/AddPrize";
import DailyActivity from "../components/operation/daily/DailyActivity";
import ConfigPiece from "../components/operation/daily/ConfigPiece";
import VideoList from "../components/product/VideoList";
import PacketList from "../components/operation/PacketList";
import TaskConfig from "../components/operation/TaskConfig";
import HeadList from "../components/config/HeadList";
import SendList from "../components/operation/SendList";
import UserBehaviorReport from "../components/report/UserBehaviorReport";
import WeekActivitySummary from "../components/operation/WeekActivitySummary";
import PieceActivitySummary from "../components/operation/PieceActivitySummary";
import CashOutConfig from "../components/operation/CashOutConfig";
import CashOutDailyReport from "../components/operation/CashOutDailyReport";
import CashOutUserReport from "../components/operation/CashOutUserReport";
import VersionList from "../components/product/VersionList";
import UserGameReport from "../components/report/UserGameReport";
import AdMaterialList from "../components/product/AdMaterialList";
import MaterialReport from "../components/report/MaterialReport";
import GoodsManagement from "../components/goods/GoodsManagement";
import GoodsConfig from "../components/goods/GoodsConfig";
import GoodsReport from "../components/goods/GoodsReport";
import SelectGood from "../components/goods/SelectGood";
import ExchangeRecord from "../components/goods/ExchangeRecord";
import OfficialPost from "../components/social/OfficialPost";
import OfficialAccount from "../components/social/OfficialAccount";
import OfficialTopic from "../components/social/OfficialTopic";
import PostAudit from "../components/social/PostAudit";
import AppIdConfig from "../components/out/AppIdConfig";
import PutInConfig from "../components/out/PutInConfig";
import PostReport from "../components/report/PostReport";
import AdRule from "../components/ruleconfig/AdRule";
import VersionCopy from "../components/product/VersionCopy";
import AdReport from "../components/report/AdReport";
import ChatRoomManage from "../components/chatRoom/ChatRoomManage";
import RobotManage from "../components/chatRoom/RobotManage";
import ChatRoomReport from "../components/report/ChatRoomReport";
import CoinReport from "../components/report/CoinReport";
import ShareReport from "../components/report/ShareReport";
import ClassifyReport from "../components/report/ClassifyReport";
import FeedConfig from "../components/ruleconfig/FeedConfig";
import CloseReport from "../components/report/CloseReport";
import Feedback from "../components/product/Feedback";
import ConstantConfig from "../components/ruleconfig/ConstantConfig";
import AbTestConfig from "../components/ruleconfig/AbTestConfig";
import MarkConfig from "../components/ruleconfig/MarkConfig";
import OperationConfig from "../components/ruleconfig/OperationConfig";

import OperationConfigDetail from "../components/ruleconfig/OperationConfigDetail";
import OperationConfigBook from "../components/newProject/book/OperationConfigBook";




import OperationConfigDetailBook from "../components/newProject/book/OperationConfigDetailBook";
import AiOperationConfigBook from "../components/newProject/ai/AiOperationConfigBook";
import AiOperationConfigDetailBook from "../components/newProject/ai/AiOperationConfigDetailBook";
import WmOperationConfig from "../components/newProject/womens/WmOperationConfig";
import WmOperationConfigDetail from "../components/newProject/womens/WmOperationConfigDetail";
import OperationConfigKitty from "../components/newProject/cat/OperationConfigKitty";
import OperationConfigDetailKitty from "../components/newProject/cat/OperationConfigDetailKitty";
import AdId from "../components/ruleconfig/AdId";
import AdPop from "../components/ruleconfig/AdPop";
import AttributionBlackList from "../components/attribution/AttributionBlackList.vue";
import AttributionPackageList from "../components/attribution/AttributionPackageList.vue";
import AttributionRule from "../components/attribution/AttributionRule.vue";
import FcReport from "../components/out/FcReport.vue";
import ReportDaily from "../components/out/ReportDaily.vue";
import ReportWeekly from "../components/out/ReportWeekly.vue";
import ReportMonthly from "../components/out/ReportMonthly.vue";
import LcOrder from "../components/lc/LcOrder.vue";
import WomenSysVip from "../components/newProject/womens/WomenSysVip.vue";
import AdAb from "../components/newProject/AdAb.vue";
import AdAbBook from "../components/newProject/book/AdAb.vue";
import AdAbAi from "../components/newProject/ai/AdAb.vue";
// 新项目组相关页面
import RuleConfig from "../components/newProject/RuleConfig";
import TotalRuleConfig from "../components/newProject/TotalRuleConfig";
import AppList from "../components/setting/AppList";
import AppLink from "../components/newProject/AppLink";
import BlockRule from "../components/newProject/BlockRule";
import SelectAppLink from "../components/newProject/SelectAppLink";
import ABTest from "../components/newProject/ABTest";
import Flag from "../components/newProject/cat/Flag.vue";
import DogFlag from "../components/newProject/dog/DogFlag.vue";
import Icon from "../components/newProject/Icon";
import IconCategory from "../components/newProject/IconCategory";
import SelectIcon from "../components/newProject/SelectIcon";
import SecondBlockRule from "../components/newProject/SecondBlockRule";
import CategoryManage from "../components/newProject/CategoryManage";
import SecondCategoryManage from "../components/newProject/SecondCategoryManage";
import DefaultManage from "../components/newProject/DefaultManage";
import AddMaterial from "../components/newProject/AddMaterial";
import LiveActivity from "../components/newProject/LiveActivity";
import SecondLiveActivity from "../components/newProject/SecondLiveActivity";
import Welcome from "../components/Welcome";
import CompanyManage from "../components/setting/CompanyManage";
import IosFeedback from "../components/newProject/IosFeedback";
import VersionConfig from "../components/newProject/VersionConfig";
import VersionMessage from "../components/newProject/VersionMessage";
import IosGoods from "../components/newProject/IosGoods";
import TaskManage from "../components/newProject/TaskManage";
import ShopManage from "../components/newProject/ShopManage";
import CupBoardShopManage from "../components/newProject/CupBoardShopManage.vue";

import ShopDailyManage from "../components/newProject/ShopDailyManage";
import ShelvesManage from "../components/newProject/ShelvesManage";
import SubShelvesManage from "../components/newProject/SubShelvesManage";
import ThirdShelvesManage from "../components/newProject/ThirdShelvesManage";
import OrderData from "../components/newProject/OrderData";

import BookShopManage from "../components/newProject/book/BookShopManage.vue";
import BookShopDailyManage from "../components/newProject/book/BookShopDailyManage.vue";
import BookShelvesManage from "../components/newProject/book/BookShelvesManage.vue";
import BookSubShelvesManage from "../components/newProject/book/BookSubShelvesManage.vue";
import BookThirdShelvesManage from "../components/newProject/book/BookThirdShelvesManage.vue";
import BookOrderData from "../components/newProject/book/BookOrderData.vue";
import IosBookGoods from "../components/newProject/book/IosBookGoods";
import IosBookTaskManage from "../components/newProject/book/IosBookTaskManage";
import AiBookShopManage from "../components/newProject/ai/AiBookShopManage.vue";
import AiBookShopDailyManage from "../components/newProject/ai/AiBookShopDailyManage.vue";
import AiBookShelvesManage from "../components/newProject/ai/AiBookShelvesManage.vue";
import AiBookSubShelvesManage from "../components/newProject/ai/AiBookSubShelvesManage.vue";
import AiBookThirdShelvesManage from "../components/newProject/ai/AiBookThirdShelvesManage.vue";
import AiBookOrderData from "../components/newProject/ai/AiBookOrderData.vue";
import AiIosBookGoods from "../components/newProject/ai/AiIosBookGoods";
import AiIosBookTaskManage from "../components/newProject/ai/AiIosBookTaskManage";

import CgShopManage from "../components/cg/CgShopManage.vue";
import CgShopDailyManage from "../components/cg/CgShopDailyManage.vue";
import CgShelvesManage from "../components/cg/CgShelvesManage.vue";
import CgSubShelvesManage from "../components/cg/CgSubShelvesManage.vue";
import CgThirdShelvesManage from "../components/cg/CgThirdShelvesManage.vue";
import CgOrderData from "../components/cg/CgOrderData.vue";
import CgGoods from "../components/cg/CgGoods";
import CgTaskManage from "../components/cg/CgTaskManage";
import CgOrder from "../components/cg/CgOrder.vue";

import BookOrder from "../components/newProject/book/BookOrder.vue";
import BookOrder1 from "../components/newProject/book/BookOrder1.vue";
import BookSysVip from "../components/newProject/book/BookSysVip.vue";
import AiBookSysVip from "../components/newProject/ai/AiBookSysVip.vue";
import AiBookOrder from "../components/newProject/ai/AiBookOrder.vue";
import UserOrder from "../components/product/UserOrder.vue";

import DogOrder from "../components/newProject/dog/DogOrder.vue";
import CatOrder from "../components/newProject/cat/CatOrder.vue";

import OperationConfigDetailCat from "../components/newProject/OperationConfigDetailCat";
import OperationConfigCat from "../components/newProject/OperationConfigCat";

//out模块的页面组件
import DataSourceReport from "../components/out/DataSourceReport";
import MediaDataReport from "../components/out/MediaDataReport";
import AppDataReport from "../components/out/AppDataReport";
import IncomeDataReport from "../components/out/IncomeDataReport";
import AdTypeIncomeRateReport from "../components/out/AdTypeIncomeRateReport";
import WeekDataReport from "../components/out/WeekDataReport";
import HandleCalData from "../components/out/HandleCalData";

//财务模块页面组件
import ProductFlowCashSetting from "../components/financial/ProductFlowCashSetting";
import FcMonthData from "../components/financial/FcMonthData";
import LcProxyMonthData from "../components/financial/LcProxyMonthData";
import SharedExpenses from "../components/financial/SharedExpenses";
import AppSharedExpenses from "../components/financial/AppSharedExpenses";
import HandleFinancialData from "../components/financial/HandleFinancialData";
import FcMonthRewards from "../components/financial/FcMonthRewards";
import AppSharedExpensesShare from "../components/financial/AppSharedExpensesShare";
import ProxyDataReport from "../components/out/ProxyDataReport";
import ReportReport from "../components/out/ReportReport";

import BookCover from "../components/newProject/book/BookCover";
import BookUserCategory from "../components/newProject/book/BookUserCategory";
import BookUserCustomCategory from "../components/newProject/book/BookUserCustomCategory";
import BookChannelConfig from "../components/newProject/book/BookChannelConfig";
import BookDownloadUrlConfig from "../components/newProject/book/BookDownloadUrlConfig";
import BookVersionConfig from "../components/newProject/book/BookVersionConfig";
import BookVersionMessage from "../components/newProject/book/BookVersionMessage";
import BookTotalRuleConfig from "../components/newProject/book/BookTotalRuleConfig";
import AiBookCover from "../components/newProject/ai/AiBookCover";
import AiBookTheme from "../components/newProject/ai/AiBookTheme";
import AiBookUserCategory from "../components/newProject/ai/AiBookUserCategory";
import AiBookUserCustomCategory from "../components/newProject/ai/AiBookUserCustomCategory";
import AiBookChannelConfig from "../components/newProject/ai/AiBookChannelConfig";
import AiBookDownloadUrlConfig from "../components/newProject/ai/AiBookDownloadUrlConfig";
import AiBookVersionConfig from "../components/newProject/ai/AiBookVersionConfig";
import AiBookVersionMessage from "../components/newProject/ai/AiBookVersionMessage";
import AiBookTotalRuleConfig from "../components/newProject/ai/AiBookTotalRuleConfig";
import WatchLinkedUrl from "../components/attribution/WatchLinkedUrl";
import RechargeManage from "@/components/newProject/RechargeManage";
import RechargeGroupManage from "@/components/newProject/RechargeGroupManage";
import WomensVersionConfig from "../components/newProject/womens/WomensVersionConfig";
import WomensVersionMessage from "../components/newProject/womens/WomensVersionMessage";
import TagsList from "../components/newProject/womens/TagsList.vue";
//桌面汪配置
import DogTotalRuleConfig from "../components/newProject/dog/DogTotalRuleConfig";
import DogABTest from "../components/newProject/dog/DogABTest";
import DogIosGoods from "../components/newProject/dog/DogIosGoods";
import DogRechargeManage from "../components/newProject/dog/DogRechargeManage";
import DogShopManage from "../components/newProject/dog/DogShopManage";
import DogTaskManage from "../components/newProject/dog/DogTaskManage";
import WomensTotalRuleConfig from "../components/newProject/womens/WomensTotalRuleConfig";
import OperationConfigDetailDog from "../components/newProject/dog/OperationConfigDetailDog";
import OperationConfigDog from "../components/newProject/dog/OperationConfigDog";


//心动萌宠配置
import CatGatherTotalRuleConfig from "../components/newProject/cat_gather/CatGatherTotalRuleConfig";
import OperationConfigDetailCatGather from "../components/newProject/cat_gather/OperationConfigDetailCatGather";
import OperationConfigCatGather from "../components/newProject/cat_gather/OperationConfigCatGather";

const originRouter = Router.prototype.push
Router.prototype.push = function push(location) {
    return originRouter.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index,
            redirect: '/welcome',
            children: [
                {
                    path: 'indexConfig',
                    name: "IndexConfig",
                    component: IndexConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'matrixConfig',
                    name: "MatrixConfig",
                    component: MatrixConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'modelConfig',
                    name: "ModelConfig",
                    component: ModelConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'lcOrder',
                    name: "LcOrder",
                    component: LcOrder,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "/gameList",
                    name: "GameList",
                    component: GameList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "/videoList",
                    name: "VideoList",
                    component: VideoList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "/packetList",
                    name: "PacketList",
                    component: PacketList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "/taskConfig",
                    name: "TaskConfig",
                    component: TaskConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "/adConfig",
                    name: "AdConfig",
                    component: AdConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "/prizeReport",
                    name: "PrizeReport",
                    component: PrizeReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "/headList",
                    name: "HeadList",
                    component: HeadList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "/sendList",
                    name: "SendList",
                    component: SendList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "gameLabelList",
                    name: "GameLabelList",
                    component: GameLabelList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "channelList",
                    name: "ChannelList",
                    component: ChannelList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "eventList",
                    name: "EventList",
                    component: EventList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/versionList',
                    name: "VersionList",
                    component: VersionList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "adMaterialList",
                    name: "AdMaterialList",
                    component: AdMaterialList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "dataReport",
                    name: "DataReport",
                    component: DataReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "functionReport",
                    name: "FunctionReport",
                    component: FunctionReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "eventReport",
                    name: "EventReport",
                    component: EventReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "matrixReport",
                    name: "MatrixReport",
                    component: MatrixReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "gameSourceReport",
                    name: "GameSourceReport",
                    component: GameSourceReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "miniReport",
                    name: "MiniReport",
                    component: MiniReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "materialReport",
                    name: "MaterialReport",
                    component: MaterialReport,
                    meta: {
                        requireAuth: true
                    }
                },
                //发现页管理
                {
                    path: "discoverConfig",
                    name: "DiscoverConfig",
                    component: DiscoverConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "discoverList",
                    name: "DiscoverList",
                    component: DiscoverList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "discoverDetail",
                    name: "DiscoverDetail",
                    component: DiscoverDetail,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "bannerDiscoverDetail",
                    name: "BannerDiscoverDetail",
                    component: BannerDiscoverDetail,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "remenDiscoverDetail",
                    name: "RemenDiscoverDetail",
                    component: RemenDiscoverDetail,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "wenzhangDiscoverDetail",
                    name: "WenzhangDiscoverDetail",
                    component: WenzhangDiscoverDetail,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "plateGameReport",
                    name: "PlateGameReport",
                    component: PlateGameReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "jumpGameReport",
                    name: "JumpGameReport",
                    component: JumpGameReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "videoReport",
                    name: "videoReport",
                    component: VideoReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "userBehaviorReport",
                    name: "UserBehaviorReport",
                    component: UserBehaviorReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: "userGameReport",
                    name: "UserGameReport",
                    component: UserGameReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/activityConfig',
                    name: "ActivityConfig",
                    component: ActivityConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/dailyActivity',
                    name: "DailyActivity",
                    component: DailyActivity,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/addPrize',
                    name: "AddPrize",
                    component: AddPrize,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/configPiece',
                    name: "ConfigPiece",
                    component: ConfigPiece,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/activitySummary',
                    name: "ActivitySummary",
                    component: ActivitySummary,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/weekActivitySummary',
                    name: "WeekActivitySummary",
                    component: WeekActivitySummary,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/pieceActivitySummary',
                    name: "PieceActivitySummary",
                    component: PieceActivitySummary,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/cashOutConfig',
                    name: "CashOutConfig",
                    component: CashOutConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/cashOutUserReport',
                    name: "CashOutUserReport",
                    component: CashOutUserReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/cashOutDailyReport',
                    name: "CashOutDailyReport",
                    component: CashOutDailyReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/userList',
                    name: "UserList",
                    component: UserList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/roleList',
                    name: "RoleList",
                    component: RoleList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/permission',
                    name: "Permission",
                    component: Permission,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'goodsManagement',
                    name: "GoodsManagement",
                    component: GoodsManagement,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'goodsConfig',
                    name: "GoodsConfig",
                    component: GoodsConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'goodsReport',
                    name: "GoodsReport",
                    component: GoodsReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'selectGood',
                    name: "SelectGood",
                    component: SelectGood,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'officialAccount',
                    name: "OfficialAccount",
                    component: OfficialAccount,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'officialPost',
                    name: "OfficialPost",
                    component: OfficialPost,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'officialTopic',
                    name: "OfficialTopic",
                    component: OfficialTopic,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'postAudit',
                    name: "PostAudit",
                    component: PostAudit,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'postReport',
                    name: "PostReport",
                    component: PostReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'adRule',
                    name: "AdRule",
                    component: AdRule,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'versionCopy',
                    name: "VersionCopy",
                    component: VersionCopy,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'adReport',
                    name: "AdReport",
                    component: AdReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'chatRoomManage',
                    name: "ChatRoomManage",
                    component: ChatRoomManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'robotManage',
                    name: "RobotManage",
                    component: RobotManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'chatRoomReport',
                    name: "ChatRoomReport",
                    component: ChatRoomReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'closeReport',
                    name: "CloseReport",
                    component: CloseReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'coinReport',
                    name: "CoinReport",
                    component: CoinReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'shareReport',
                    name: "ShareReport",
                    component: ShareReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'feedConfig',
                    name: "FeedConfig",
                    component: FeedConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'classifyReport',
                    name: "ClassifyReport",
                    component: ClassifyReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'exchangeRecord',
                    name: "ExchangeRecord",
                    component: ExchangeRecord,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'feedback',
                    name: "Feedback",
                    component: Feedback,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'constantConfig',
                    name: "ConstantConfig",
                    component: ConstantConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'abTestConfig',
                    name: "AbTestConfig",
                    component: AbTestConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'markConfig',
                    name: "MarkConfig",
                    component: MarkConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'adId',
                    name: "AdId",
                    component: AdId,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'adPop',
                    name: "AdPop",
                    component: AdPop,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'operationConfig',
                    name: "OperationConfig",
                    component: OperationConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'operationConfigDetail',
                    name: "OperationConfigDetail",
                    component: OperationConfigDetail,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'operationConfigBook',
                    name: "OperationConfigBook",
                    component: OperationConfigBook,
                    meta: {
                        requireAuth: true
                    }
                },
                //cat
                //
                {
                    path: 'operationConfigDetailCat',
                    name: "OperationConfigDetailCat",
                    component: OperationConfigDetailCat,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'operationConfigCat',
                    name: "OperationConfigCat",
                    component: OperationConfigCat,
                    meta: {
                        requireAuth: true
                    }
                },
                //catgager
                {
                    path: 'operationConfigDetailCatGather',
                    name: "OperationConfigDetailCatGather",
                    component: OperationConfigDetailCatGather,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'operationConfigCatGather',
                    name: "OperationConfigCatGather",
                    component: OperationConfigCatGather,
                    meta: {
                        requireAuth: true
                    }
                },
                //dog
                {
                    path: 'operationConfigDetailDog',
                    name: "OperationConfigDetailDog",
                    component: OperationConfigDetailDog,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'operationConfigDog',
                    name: "OperationConfigDog",
                    component: OperationConfigDog,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'wmOperationConfig',
                    name: "WmOperationConfig",
                    component: WmOperationConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiOperationConfigBook',
                    name: "AiOperationConfigBook",
                    component: AiOperationConfigBook,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'operationConfigKitty',
                    name: "OperationConfigKitty",
                    component: OperationConfigKitty,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'operationConfigDetailBook',
                    name: "OperationConfigDetailBook",
                    component: OperationConfigDetailBook,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'wmOperationConfigDetail',
                    name: "WmOperationConfigDetail",
                    component: WmOperationConfigDetail,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiOperationConfigDetailBook',
                    name: "AiOperationConfigDetailBook",
                    component: AiOperationConfigDetailBook,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'operationConfigDetailKitty',
                    name: "OperationConfigDetailKitty",
                    component: OperationConfigDetailKitty,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'ruleConfig',
                    name: "RuleConfig",
                    component: RuleConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'totalRuleConfig',
                    name: "TotalRuleConfig",
                    component: TotalRuleConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'dogTotalRuleConfig',
                    name: "DogTotalRuleConfig",
                    component: DogTotalRuleConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'womensTotalRuleConfig',
                    name: "WomensTotalRuleConfig",
                    component: WomensTotalRuleConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/appList',
                    name: "AppList",
                    component: AppList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'appLink',
                    name: "AppLink",
                    component: AppLink,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'blockRule',
                    name: "BlockRule",
                    component: BlockRule,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'selectAppLink',
                    name: "SelectAppLink",
                    component: SelectAppLink,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'abTest',
                    name: "ABTest",
                    component: ABTest,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'flag',
                    name: "Flag",
                    component: Flag,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'dogFlag',
                    name: "DogFlag",
                    component: DogFlag,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'catGatherTotalRuleConfig',
                    name: "CatGatherTotalRuleConfig",
                    component: CatGatherTotalRuleConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'dogAbTest',
                    name: "DogAbTest",
                    component: DogABTest,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'icon',
                    name: "Icon",
                    component: Icon,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'iconCategory',
                    name: "IconCategory",
                    component: IconCategory,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'selectIcon',
                    name: "SelectIcon",
                    component: SelectIcon,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'secondBlockRule',
                    name: "SecondBlockRule",
                    component: SecondBlockRule,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'categoryManage',
                    name: "CategoryManage",
                    component: CategoryManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'secondCategoryManage',
                    name: "SecondCategoryManage",
                    component: SecondCategoryManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'defaultManage',
                    name: "DefaultManage",
                    component: DefaultManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'addMaterial',
                    name: "AddMaterial",
                    component: AddMaterial,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'liveActivity',
                    name: "LiveActivity",
                    component: LiveActivity,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'secondLiveActivity',
                    name: "SecondLiveActivity",
                    component: SecondLiveActivity,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'appIdConfig',
                    name: "AppIdConfig",
                    component: AppIdConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'putInConfig',
                    name: "PutInConfig",
                    component: PutInConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'welcome',
                    name: 'Welcome',
                    component: Welcome,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'companyManage',
                    name: 'CompanyManage',
                    component: CompanyManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'iosFeedback',
                    name: 'IosFeedback',
                    component: IosFeedback,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'versionConfig',
                    name: 'VersionConfig',
                    component: VersionConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'versionMessage',
                    name: 'VersionMessage',
                    component: VersionMessage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'iosGoods',
                    name: 'IosGoods',
                    component: IosGoods,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'dogIosGoods',
                    name: 'DogIosGoods',
                    component: DogIosGoods,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'dataSourceReport',
                    name: 'DataSourceReport',
                    component: DataSourceReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'mediaDataReport',
                    name: 'MediaDataReport',
                    component: MediaDataReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'appDataReport',
                    name: 'AppDataReport',
                    component: AppDataReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'incomeDataReport',
                    name: 'IncomeDataReport',
                    component: IncomeDataReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'adTypeIncomeRateReport',
                    name: 'AdTypeIncomeRateReport',
                    component: AdTypeIncomeRateReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'weekDataReport',
                    name: 'WeekDataReport',
                    component: WeekDataReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'handleCalData',
                    name: 'HandleCalData',
                    component: HandleCalData,
                    meta: {
                        requireAuth: true
                    }
                },
                //财务模块页面组件
                {
                    path: 'productFlowCashSetting',
                    name: "ProductFlowCashSetting",
                    component: ProductFlowCashSetting,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'fcMonthData',
                    name: "FcMonthData",
                    component: FcMonthData,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'lcProxyMonthData',
                    name: "LcProxyMonthData",
                    component: LcProxyMonthData,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'handleFinancialData',
                    name: "HandleFinancialData",
                    component: HandleFinancialData,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: 'fcMonthRewards',
                    name: "FcMonthRewards",
                    component: FcMonthRewards,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'sharedExpenses',
                    name: "SharedExpenses",
                    component: SharedExpenses,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'appSharedExpenses',
                    name: "AppSharedExpenses",
                    component: AppSharedExpenses,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'appSharedExpensesShare',
                    name: "AppSharedExpensesShare",
                    component: AppSharedExpensesShare,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'proxyDataReport',
                    name: "ProxyDataReport",
                    component: ProxyDataReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'reportReport',
                    name: "ReportReport",
                    component: ReportReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'taskManage',
                    name: "TaskManage",
                    component: TaskManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'dogTaskManage',
                    name: "DogTaskManage",
                    component: DogTaskManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'shopManage',
                    name: "ShopManage",
                    component: ShopManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'cupBoardShopManage',
                    name: "CupBoardShopManage",
                    component: CupBoardShopManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'dogShopManage',
                    name: "DogShopManage",
                    component: DogShopManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookShopManage',
                    name: "BookShopManage",
                    component: BookShopManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookShopManage',
                    name: "AiBookShopManage",
                    component: AiBookShopManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'cgShopManage',
                    name: "CgShopManage",
                    component: CgShopManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'rechargeManage',
                    name: "RechargeManage",
                    component: RechargeManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'dogRechargeManage',
                    name: "DogRechargeManage",
                    component: DogRechargeManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'rechargeGroupManage',
                    name: "RechargeGroupManage",
                    component: RechargeGroupManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'shopDailyManage',
                    name: "ShopDailyManage",
                    component: ShopDailyManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'shelvesManage',
                    name: "ShelvesManage",
                    component: ShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'subShelvesManage',
                    name: "SubShelvesManage",
                    component: SubShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'thirdShelvesManage',
                    name: "ThirdShelvesManage",
                    component: ThirdShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'orderData',
                    name: "OrderData",
                    component: OrderData,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookShopDailyManage',
                    name: "BookShopDailyManage",
                    component: BookShopDailyManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookShelvesManage',
                    name: "BookShelvesManage",
                    component: BookShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookSubShelvesManage',
                    name: "BookSubShelvesManage",
                    component: BookSubShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookThirdShelvesManage',
                    name: "BookThirdShelvesManage",
                    component: BookThirdShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookOrderData',
                    name: "BookOrderData",
                    component: BookOrderData,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookShopDailyManage',
                    name: "AiBookShopDailyManage",
                    component: AiBookShopDailyManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookShelvesManage',
                    name: "AiBookShelvesManage",
                    component: AiBookShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookSubShelvesManage',
                    name: "AiBookSubShelvesManage",
                    component: AiBookSubShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookThirdShelvesManage',
                    name: "AiBookThirdShelvesManage",
                    component: AiBookThirdShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookOrderData',
                    name: "AiBookOrderData",
                    component: AiBookOrderData,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'cgShopDailyManage',
                    name: "CgShopDailyManage",
                    component: CgShopDailyManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'cgShelvesManage',
                    name: "CgShelvesManage",
                    component: CgShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'cgSubShelvesManage',
                    name: "CgSubShelvesManage",
                    component: CgSubShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'cgThirdShelvesManage',
                    name: "CgThirdShelvesManage",
                    component: CgThirdShelvesManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'cgOrderData',
                    name: "CgOrderData",
                    component: CgOrderData,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookOrder',
                    name: "BookOrder",
                    component: BookOrder,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookOrder1',
                    name: "BookOrder1",
                    component: BookOrder1,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookSysVip',
                    name: "BookSysVip",
                    component: BookSysVip,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'womenSysVip',
                    name: "WomenSysVip",
                    component: WomenSysVip,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'adAb',
                    name: "AdAb",
                    component: AdAb,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'adAbBook',
                    name: "AdAbBook",
                    component: AdAbBook,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'adAbAi',
                    name: "AdAbAi",
                    component: AdAbAi,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookSysVip',
                    name: "AiBookSysVip",
                    component: AiBookSysVip,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookOrder',
                    name: "AiBookOrder",
                    component: AiBookOrder,
                    meta: {
                        requireAuth: true
                    }
                }
                ,{
                    path: 'userOrder',
                    name: "UserOrder",
                    component: UserOrder,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'cgOrder',
                    name: "CgOrder",
                    component: CgOrder,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'dogOrder',
                    name: "DogOrder",
                    component: DogOrder,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'catOrder',
                    name: "CatOrder",
                    component: CatOrder,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'iosBookGoods',
                    name: "IosBookGoods",
                    component: IosBookGoods,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'iosBookTaskManage',
                    name: "IosBookTaskManage",
                    component: IosBookTaskManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiIosBookGoods',
                    name: "AiIosBookGoods",
                    component: AiIosBookGoods,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiIosBookTaskManage',
                    name: "AiIosBookTaskManage",
                    component: AiIosBookTaskManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'cgGoods',
                    name: "CgGoods",
                    component: CgGoods,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'cgTaskManage',
                    name: "CgTaskManage",
                    component: CgTaskManage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookCover',
                    name: "BookCover",
                    component: BookCover,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookUserCategory',
                    name: "BookUserCategory",
                    component: BookUserCategory,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookUserCustomCategory',
                    name: "BookUserCustomCategory",
                    component: BookUserCustomCategory,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookChannelConfig',
                    name: "BookChannelConfig",
                    component: BookChannelConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookDownloadUrlConfig',
                    name: "BookDownloadUrlConfig",
                    component: BookDownloadUrlConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookVersionConfig',
                    name: "BookVersionConfig",
                    component: BookVersionConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookVersionMessage',
                    name: "BookVersionMessage",
                    component: BookVersionMessage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'bookTotalRuleConfig',
                    name: "BookTotalRuleConfig",
                    component: BookTotalRuleConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookCover',
                    name: "AiBookCover",
                    component: AiBookCover,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookTheme',
                    name: "AiBookTheme",
                    component: AiBookTheme,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookUserCategory',
                    name: "AiBookUserCategory",
                    component: AiBookUserCategory,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookUserCustomCategory',
                    name: "AiBookUserCustomCategory",
                    component: AiBookUserCustomCategory,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookChannelConfig',
                    name: "AiBookChannelConfig",
                    component: AiBookChannelConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookDownloadUrlConfig',
                    name: "AiBookDownloadUrlConfig",
                    component: AiBookDownloadUrlConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookVersionConfig',
                    name: "AiBookVersionConfig",
                    component: AiBookVersionConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookVersionMessage',
                    name: "AiBookVersionMessage",
                    component: AiBookVersionMessage,
                    meta: {
                        requireAuth: true
                    }
                },
                //
                {
                    path: 'womensVersionConfig',
                    name: "WomensVersionConfig",
                    component: WomensVersionConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'womensVersionMessage',
                    name: "WomensVersionMessage",
                    component: WomensVersionMessage,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'tagsList',
                    name: "tagsList",
                    component: TagsList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'aiBookTotalRuleConfig',
                    name: "AiBookTotalRuleConfig",
                    component: AiBookTotalRuleConfig,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'attributionBlackList',
                    name: "attributionBlackList",
                    component: AttributionBlackList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'attributionPackageList',
                    name: "attributionPackageList",
                    component: AttributionPackageList,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'attributionRule',
                    name: "attributionRule",
                    component: AttributionRule,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'watchLinkedUrl',
                    name: "watchLinkedUrl",
                    component: WatchLinkedUrl,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'fcReport',
                    name: "fcReport",
                    component: FcReport,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'reportDaily',
                    name: "reportDaily",
                    component: ReportDaily,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'reportWeekly',
                    name: "reportWeekly",
                    component: ReportWeekly,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: 'reportMonthly',
                    name: "reportMonthly",
                    component: ReportMonthly,
                    meta: {
                        requireAuth: true
                    }
                },
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        }
    ]
})
